import { post, del, get } from './generic.api';

export const fetchGroupers = async (clientId) => {
    try {
      const response = await get('/groupers/', {
            client: clientId 
      });
      return response.results;
    } catch (error) {
      console.error('Erro ao buscar groupers:', error.response);
      throw error;
    }
  };

  export const fetchGroupersData = async (clippingId) => {
    try {
      const response = await get('/groupers-data/', {
            clipping: clippingId 
      });
      return response.results;
    } catch (error) {
      console.error('Erro ao buscar groupers-data:', error.response);
      throw error;
    }
  };

  export const sendEvaluationData = async (filterData) => {
    try {
      const response = await post('/groupers-data/mass_evaluation/', filterData);
      return response;
    } catch (error) {
      console.error('Erro ao enviar dados de avaliação:', error.response);
      throw error;
    }
  };

  export const fetchSubjects = async (clientId) => {
    try {
        const response = await get('/groupers/evaluation_data/', {
            client: clientId
        });
        return response;
    } catch (error) {
        console.error('Erro ao buscar subjects:', error.response);
        throw error;
    }
};

export const fetchClientSubjects = async (clientId, subject, limit = 20) => {
  try {
      const response = await get('/groupers/client-subjects/', {
        client: clientId,
        subject,
        limit,
      });
      return response;
  } catch (error) {
      console.error('Erro ao buscar client subjects:', error.response);
      throw error;
  }
};

export const replicateEvaluation = async (clippingId, clippingsDuplicate) => {
  try {
    const response = await post('/groupers-data/replicate-evaluation/', {
      clipping: clippingId,
      clippings_duplicate: clippingsDuplicate
    });
    return response;
  } catch (error) {
    console.error('Erro ao replicar avaliação:', error.response);
    throw error;
  }
};

export const fetchAuditLog = async (clippingId) => {
  try {
    const response = await get('/groupers-data/audit-log/', {
      clipping: clippingId
    });
    return response;
  } catch (error) {
    console.error('Erro ao buscar histórico de avaliação:', error.response);
    throw error;
  }
};